import {signOut} from 'aws-amplify/auth';
import {cognito} from '../config/amplify/auth';
import {stage} from '../config/stage';

// FNP-1685: a bare signOut() REJECTS on every deployed stage. Amplify clears the
// tokens first, then refuses the logout redirect because redirectSignOut is the
// portal, a different origin (InvalidOriginException). Naming this stage's
// portal as the preferred redirect makes Amplify send the browser through the
// broker's /logout to the portal.
// signOut() also RESOLVES WITHOUT NAVIGATING when there is no OAuth session, so
// the page leaves for '/' on a timer. A slow broker /logout can still be loading
// when the timer fires, so `beforeunload` (fired once Amplify's navigation starts)
// disarms it. The catch honours it too: a rejection after the navigation began
// must not cancel it. No `finally`: it would override Amplify's navigation.
export const SIGN_OUT_FALLBACK_MS = 3000;

export const signOutToPortal = async () => {
    let leaving = false;
    const onLeave = () => {
        leaving = true;
    };
    window.addEventListener('beforeunload', onLeave);
    try {
        const redirectUrl = cognito[stage].redirectSignOut[0];
        await signOut({global: false, oauth: {redirectUrl}});
        setTimeout(() => {
            if (!leaving) {
                window.location.href = '/';
            }
        }, SIGN_OUT_FALLBACK_MS);
    } catch (error) {
        console.error('Sign out did not complete cleanly', error);
        if (!leaving) {
            window.location.href = '/';
        }
    }
};
